// extracted by mini-css-extract-plugin
export default {"container":"ProjectCard_container__cYF-s","body":"ProjectCard_body__Sc5hB"};